import { useSeo } from './useSeo'

/**
 * Заголовок и описание документа по маршруту.
 *
 * Пустой компонент, а не хук в корневом: мету надо ставить ВНУТРИ провайдеров —
 * язык берётся оттуда, — а корневой компонент их как раз и монтирует.
 */
export function Head() {
  useSeo()
  return null
}
